/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/


  

  

  

  



  

  

  

  

  

  

  


export const Statuses = {"NEW":"new","STARTED":"started","COMPLETE":"complete","ERROR":"error"};

export const DataJobs = {"PARTICIPANTS":{"id":"1"},"PROJECT_INVITED_PARTICIPANTS":{"id":"10"},"CALENDAR_SYNC":{"id":"11"},"BULK_EMAIL_PROJECT_PARTICIPANTS":{"id":"12"},"PROJECT_PARTICIPANT_INVITES":{"id":"13"},"PROJECT_BULK_SIGNATURES":{"id":"14"},"LEDGER_ENTRIES":{"id":"15"}}
